import * as api from './verify-identity-api';
import { setPatientData } from '../../patient/patient-middleware';
import * as MsgBarActions from '../../system-shared/message-bar-action-creator';
import { setVerificationFields, setSignUpVerifiedIdentityData } from '../signup-action-creator';
import history from '../../../../history';

export const loadPatientInviteResponseValidation = (patient) => (dispatch) => {
  const { firstName, lastName, year, month, day, pin, mrn, ssn } = patient;
  const birthDate = `${year}/${month}/${day}`;
  return api.postPatientInviteResponseValidation(firstName, lastName,
    birthDate, pin, mrn, ssn)
    .then((response) => {
      dispatch(setPatientData(response.data));
      dispatch(
        setSignUpVerifiedIdentityData(
          { firstName, lastName, birthDate, pin, mrn, ssn }
        )); // Need to use this when creating account
      history.push('/create-account');
    })
    .catch(() => {
      dispatch(MsgBarActions.showErrorMessage('signUpVerifyIdentityFailure'));
    });
};

export const loadVerificationFields = () => (dispatch) => {
  api.getVerificationFields()
    .then((response) => dispatch(setVerificationFields(response.data)));
};
